import { useMatch } from 'react-router-dom';
import { ROUTES, slugToId } from '../../routes';
import { useBreathworks } from '@breath-lab/state';
import { getPrimaryName } from '../../domain/breathworkNameDisplay';
import { useBreathworkNameDisplay } from './useBreathworkNameDisplay';

export function usePageTitle(): string {
  const matchPlay         = useMatch(ROUTES.breathworkPlay);
  const matchSuccess      = useMatch(ROUTES.breathworkSuccess);
  const matchConfigure    = useMatch(ROUTES.breathworkConfigure);
  const matchDetail       = useMatch(ROUTES.breathworkDetail);
  const matchJourneys      = useMatch(ROUTES.journeys);
  const matchJourneyDetail = useMatch(ROUTES.journeyDetail);
  const matchBreathworks  = useMatch(ROUTES.breathworks);
  const matchHome         = useMatch(ROUTES.loggedInHome);
  const matchActivity        = useMatch(ROUTES.activity);
  const matchActivityDetail  = useMatch(ROUTES.activityDetail);
  const matchAchievements    = useMatch(ROUTES.achievements);
  const matchAchievementDetail = useMatch(ROUTES.achievementDetail);
  const matchProfile         = useMatch(ROUTES.profile);

  const display = useBreathworkNameDisplay();
  const { breathworks } = useBreathworks();
  const configuredBreathwork = breathworks.find((b) => b.id === slugToId(matchConfigure?.params.id ?? ''));

  if (matchPlay)          return '';
  if (matchSuccess)       return 'Session Complete';
  if (matchConfigure)     return configuredBreathwork
    ? getPrimaryName(configuredBreathwork.name, display)
    : '';
  if (matchDetail) return '';
  if (matchJourneys)       return 'Journeys';
  if (matchJourneyDetail)  return 'Journeys';
  if (matchBreathworks)   return 'Breathworks';
  if (matchHome)          return '';
  if (matchActivity)           return 'Activity';
  if (matchActivityDetail)     return 'Activity';
  if (matchAchievements)       return 'Achievements';
  if (matchAchievementDetail)  return 'Achievements';
  if (matchProfile)       return 'Profile';
  return '';
}
